var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationIntro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 580,
    height: 525,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "126.9%",
    height: "129.8%",
    x: "-13.5%",
    y: "-10.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.311765745 0 0 0 0 0.336514196 0 0 0 0 0.386011096 0 0 0 0.03 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: "126.9%",
    height: "129.8%",
    x: "-13.5%",
    y: "-10.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.311765745 0 0 0 0 0.336514196 0 0 0 0 0.386011096 0 0 0 0.03 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: "126.9%",
    height: "129.8%",
    x: "-13.5%",
    y: "-10.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.311765745 0 0 0 0 0.336514196 0 0 0 0 0.386011096 0 0 0 0.03 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 260,
    height: 235,
    x: 0,
    y: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f",
    width: 260,
    height: 235,
    x: 0,
    y: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "j",
    width: 260,
    height: 235,
    x: 0,
    y: 0,
    rx: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "a",
    cx: 81.039,
    cy: 81.034,
    rx: 81.039,
    ry: 81.034
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "b",
    cx: 81.039,
    cy: 81.034,
    rx: 81.039,
    ry: 81.034
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    width: 162.078,
    height: 162.069,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    width: 162.078,
    height: 162.069,
    x: 0,
    y: 0,
    fill: "#fff",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(20 10)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    stroke: "#E5E9EA",
    d: "M16.208 16.207h230.286v202.586H16.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E9EA",
    d: "M16.208 117.5h230.286v1H16.208zM16.208 136.493h230.286v1H16.208zM16.208 155.485h230.286v1H16.208zM16.208 174.477h230.286v1H16.208zM16.208 41.53h230.286v1H16.208zM16.208 22.538h230.286v1H16.208zM16.208 60.523h230.286v1H16.208zM16.208 79.515h230.286v1H16.208zM16.208 98.508h230.286v1H16.208zM16.208 193.47h230.286v1H16.208zM16.208 212.462h230.286v1H16.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242D52",
    d: "M22.286 117.5h31.065v45.647a5 5 0 01-5 5H27.286a5 5 0 01-5-5V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3603C",
    d: "M22.286 117.5h31.065v32.985a5 5 0 01-5 5H27.286a5 5 0 01-5-5V117.5zM69.558 117.234h31.065V82.658a5 5 0 00-5-5H74.558a5 5 0 00-5 5v34.576z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242D52",
    d: "M69.558 117.234h31.065v51.99a5 5 0 01-5 5H74.558a5 5 0 01-5-5v-51.99zM162.078 117.5h31.065V46.193a5 5 0 00-5-5h-21.065a5 5 0 00-5 5V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3603C",
    d: "M162.078 117.5h31.065V65.27a5 5 0 00-5-5h-21.065a5 5 0 00-5 5v52.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#242D52",
    d: "M209.351 117.5h31.065v58.477a5 5 0 01-5 5H214.35a5 5 0 01-5-5V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3603C",
    d: "M209.351 117.5h31.065v45.782a5 5 0 01-5 5H214.35a5 5 0 01-5-5V117.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3603C",
    d: "M115.481 117.5h31.065v90.216a5 5 0 01-5 5H120.48a5 5 0 01-5-5V117.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242D52",
    d: "M115.481 117.5h31.065v33.086a5 5 0 01-5 5H120.48a5 5 0 01-5-5V117.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#e)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.299 36.466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.039,
    cy: 81.034,
    stroke: "#FFF",
    strokeWidth: 40,
    rx: 61.039,
    ry: 61.034
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#F3603C",
    strokeDasharray: 502,
    strokeWidth: 80,
    mask: "url(#g)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#242D52",
    strokeDasharray: 340,
    strokeWidth: 80,
    mask: "url(#h)",
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140 250)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#i)",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.208 140.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.026,
    height: 78.333,
    fill: "#F3603C",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M23.044 59.413v-3.907h3.897v-1.78h-3.897v-3.908h-1.781v3.907h-3.908v1.78h3.908v3.908h1.78zm12.264 2.038V47.345H33.15l-3.433 2.997v2.374l3.314-2.977V61.45h2.276zm6.437.198c.382 0 .71-.135.984-.406.274-.27.41-.597.41-.98 0-.382-.136-.71-.41-.983a1.343 1.343 0 00-.984-.41c-.376 0-.702.136-.98.41a1.335 1.335 0 00-.415.984c0 .376.139.7.416.974.277.274.603.41.979.41zm8.584-.01c1.45 0 2.623-.444 3.517-1.33.893-.888 1.34-2.053 1.34-3.497 0-1.438-.438-2.544-1.316-3.32-.877-.774-2.199-1.161-3.966-1.161H48.36l.307-2.918h5.876v-2.058H46.68l-.732 6.914h3.63c2.21 0 3.314.874 3.314 2.622 0 .791-.232 1.43-.697 1.914-.465.485-1.103.727-1.915.727-.705 0-1.307-.205-1.805-.613-.498-.41-.747-1.023-.747-1.84 0-.165.023-.403.07-.712l-2.286.138c-.033.284-.05.521-.05.712 0 .917.228 1.716.683 2.399a4.204 4.204 0 001.771 1.523c.726.333 1.53.5 2.414.5zm9.207-8.29a2.96 2.96 0 002.186-.91c.6-.613.9-1.348.9-2.205 0-.851-.3-1.58-.9-2.187a2.96 2.96 0 00-2.186-.91c-.85 0-1.58.304-2.186.91a2.981 2.981 0 00-.91 2.187c0 .863.302 1.599.905 2.205.603.607 1.334.91 2.191.91zm1.088 8.112l7.46-14.136h-1.98l-7.438 14.136h1.958zm-1.088-9.684c-.422 0-.785-.15-1.088-.45a1.48 1.48 0 01-.455-1.093c0-.43.152-.79.455-1.084a1.51 1.51 0 011.088-.44c.429 0 .792.149 1.088.445.297.297.445.656.445 1.079 0 .428-.146.793-.44 1.093-.293.3-.658.45-1.093.45zm7.785 9.842c.851 0 1.575-.303 2.172-.91a3.006 3.006 0 00.895-2.186c0-.857-.3-1.588-.9-2.191a2.945 2.945 0 00-2.167-.905c-.857 0-1.589.301-2.196.905a2.976 2.976 0 00-.91 2.191c0 .857.302 1.588.905 2.191.604.603 1.338.905 2.201.905zm0-1.563c-.435 0-.8-.15-1.098-.45a1.485 1.485 0 01-.445-1.083c0-.435.149-.801.445-1.098a1.492 1.492 0 011.098-.445c.416 0 .777.151 1.084.455.306.303.46.666.46 1.088 0 .422-.152.783-.455 1.083-.304.3-.666.45-1.089.45z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(137.766 140.46)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.026,
    height: 78.333,
    fill: "#FAFAFA",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E272E",
    fillRule: "nonzero",
    d: "M22.104 61.639c.936 0 1.777-.168 2.522-.505a4.186 4.186 0 001.776-1.503c.439-.66.658-1.421.658-2.285 0-.85-.218-1.593-.653-2.226a4.118 4.118 0 00-1.77-1.444c.527-.31.942-.714 1.246-1.212a3.14 3.14 0 00.455-1.667c0-1.068-.4-1.943-1.202-2.626-.801-.682-1.812-1.024-3.032-1.024-1.24 0-2.262.34-3.067 1.02-.804.678-1.207 1.555-1.207 2.63 0 .614.155 1.17.465 1.667.31.498.736.902 1.276 1.212-.758.323-1.353.801-1.785 1.434-.432.633-.648 1.379-.648 2.236 0 .864.22 1.625.658 2.285a4.147 4.147 0 001.78 1.498c.749.34 1.591.51 2.528.51zm0-8.665c-.607 0-1.118-.197-1.533-.589a1.926 1.926 0 01-.624-1.459c0-.567.208-1.044.624-1.43.415-.385.926-.578 1.533-.578.6 0 1.108.193 1.523.579.416.385.624.862.624 1.429 0 .574-.21 1.058-.629 1.454a2.131 2.131 0 01-1.518.594zm0 6.607c-.772 0-1.411-.227-1.92-.682-.507-.455-.761-1.062-.761-1.82 0-.745.254-1.342.762-1.79.508-.45 1.147-.673 1.919-.673.758 0 1.391.224 1.9.672.507.449.761 1.046.761 1.79 0 .753-.254 1.358-.762 1.816-.508.458-1.14.687-1.9.687zM33.18 61.64c.936 0 1.777-.168 2.522-.505a4.186 4.186 0 001.776-1.503c.439-.66.658-1.421.658-2.285 0-.85-.218-1.593-.653-2.226a4.118 4.118 0 00-1.77-1.444c.527-.31.942-.714 1.246-1.212a3.14 3.14 0 00.455-1.667c0-1.068-.4-1.943-1.202-2.626-.801-.682-1.812-1.024-3.032-1.024-1.24 0-2.262.34-3.067 1.02-.804.678-1.207 1.555-1.207 2.63 0 .614.155 1.17.465 1.667.31.498.736.902 1.276 1.212-.758.323-1.353.801-1.785 1.434-.432.633-.648 1.379-.648 2.236 0 .864.22 1.625.658 2.285a4.147 4.147 0 001.78 1.498c.749.34 1.591.51 2.528.51zm0-8.665c-.607 0-1.118-.197-1.534-.589a1.926 1.926 0 01-.623-1.459c0-.567.208-1.044.623-1.43.416-.385.927-.578 1.534-.578.6 0 1.108.193 1.523.579.416.385.623.862.623 1.429 0 .574-.209 1.058-.628 1.454a2.131 2.131 0 01-1.518.594zm0 6.607c-.772 0-1.412-.227-1.92-.682-.507-.455-.761-1.062-.761-1.82 0-.745.254-1.342.762-1.79.507-.45 1.147-.673 1.919-.673.758 0 1.391.224 1.9.672.507.449.76 1.046.76 1.79 0 .753-.253 1.358-.76 1.816-.509.458-1.142.687-1.9.687zm8.435 2.068c.383 0 .711-.135.985-.406.273-.27.41-.597.41-.98 0-.382-.137-.71-.41-.983a1.343 1.343 0 00-.985-.41c-.375 0-.702.136-.979.41a1.335 1.335 0 00-.415.984c0 .376.138.7.415.974.277.274.604.41.98.41zm13.313-.198v-2.058h-6.51l4.146-4.293c.666-.692 1.154-1.342 1.464-1.948.31-.607.465-1.27.465-1.989 0-1.253-.419-2.238-1.257-2.957-.837-.72-1.915-1.079-3.234-1.079-1.405 0-2.52.393-3.344 1.178-.824.784-1.237 1.909-1.237 3.373v.791l2.266.218v-1.039c0-.917.207-1.584.623-2.003.415-.419.983-.628 1.701-.628.686 0 1.23.19 1.633.569.402.379.603.908.603 1.587 0 .877-.471 1.8-1.414 2.77l-5.64 5.787v1.721h9.735zm9.702 0v-2.76h1.939v-2.048h-1.94v-9.298H61.16l-5.431 9.289v2.057h6.628v2.76h2.275zm-2.275-4.808h-4.412l4.412-7.834v7.834zm8.129-3.294a2.96 2.96 0 002.186-.91c.6-.613.9-1.348.9-2.205 0-.851-.3-1.58-.9-2.187a2.96 2.96 0 00-2.186-.91c-.851 0-1.58.304-2.187.91a2.981 2.981 0 00-.91 2.187c0 .863.302 1.599.905 2.205.604.607 1.334.91 2.192.91zm1.088 8.112l7.459-14.136h-1.979l-7.439 14.136h1.959zm-1.088-9.684c-.422 0-.785-.15-1.089-.45a1.48 1.48 0 01-.455-1.093c0-.43.152-.79.455-1.084a1.51 1.51 0 011.089-.44c.428 0 .791.149 1.088.445.297.297.445.656.445 1.079 0 .428-.147.793-.44 1.093-.294.3-.658.45-1.093.45zm7.785 9.842c.85 0 1.574-.303 2.171-.91a3.006 3.006 0 00.896-2.186c0-.857-.3-1.588-.9-2.191a2.945 2.945 0 00-2.167-.905c-.857 0-1.59.301-2.196.905a2.976 2.976 0 00-.91 2.191c0 .857.301 1.588.905 2.191.603.603 1.337.905 2.2.905zm0-1.563c-.435 0-.801-.15-1.098-.45a1.485 1.485 0 01-.445-1.083c0-.435.148-.801.445-1.098a1.492 1.492 0 011.098-.445c.415 0 .776.151 1.083.455.307.303.46.666.46 1.088 0 .422-.152.783-.455 1.083-.303.3-.666.45-1.088.45z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.208 16.207)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227.584,
    height: 108.046,
    fill: "#FAFAFA",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "nonzero",
    d: "M28.786 84.812c1.998 0 3.791-.359 5.381-1.076 1.59-.732 2.853-1.801 3.788-3.208.936-1.407 1.404-3.032 1.404-4.875 0-1.815-.465-3.397-1.393-4.748-.929-1.35-2.188-2.377-3.778-3.08 1.126-.662 2.012-1.524 2.66-2.586.647-1.062.97-2.247.97-3.556 0-2.279-.855-4.146-2.564-5.602-1.71-1.457-3.865-2.185-6.468-2.185-2.645 0-4.826.725-6.542 2.174-1.717 1.449-2.575 3.32-2.575 5.613 0 1.309.33 2.494.992 3.556.661 1.062 1.568 1.924 2.722 2.585-1.618.69-2.888 1.71-3.81 3.06-.92 1.35-1.381 2.94-1.381 4.77 0 1.842.467 3.467 1.403 4.874.936 1.407 2.202 2.473 3.799 3.197 1.597.725 3.394 1.087 5.392 1.087zm0-18.486c-1.295 0-2.385-.419-3.271-1.256-.887-.837-1.33-1.874-1.33-3.112 0-1.21.443-2.227 1.33-3.05.886-.823 1.976-1.234 3.27-1.234 1.281 0 2.364.411 3.25 1.234.887.823 1.33 1.84 1.33 3.05 0 1.224-.446 2.258-1.34 3.102-.893.844-1.973 1.266-3.24 1.266zm0 14.097c-1.646 0-3.011-.486-4.094-1.457-1.084-.97-1.625-2.265-1.625-3.882 0-1.59.541-2.863 1.625-3.82 1.083-.957 2.448-1.435 4.094-1.435 1.618 0 2.968.478 4.052 1.435 1.083.957 1.625 2.23 1.625 3.82 0 1.603-.542 2.894-1.625 3.872-1.084.978-2.434 1.467-4.052 1.467zm21.737 3.988l9.729-12.873c1.772-2.391 2.659-4.818 2.659-7.28 0-1.97-.479-3.746-1.435-5.329a9.904 9.904 0 00-3.894-3.682c-1.64-.872-3.458-1.308-5.455-1.308-1.956 0-3.753.432-5.392 1.297-1.64.866-2.948 2.104-3.926 3.714-.978 1.611-1.46 3.423-1.445 5.434.014 1.97.482 3.718 1.403 5.244.922 1.527 2.107 2.684 3.556 3.472a9.656 9.656 0 004.685 1.182c.661 0 1.294-.064 1.9-.19l-8.02 10.319h5.635zm1.73-13.76c-1.8 0-3.274-.565-4.421-1.698-1.147-1.132-1.727-2.62-1.741-4.463-.014-1.815.563-3.289 1.73-4.421 1.168-1.133 2.645-1.699 4.432-1.699 1.815 0 3.278.549 4.39 1.646 1.111 1.098 1.667 2.575 1.667 4.432 0 1.758-.566 3.232-1.699 4.42-1.132 1.19-2.585 1.784-4.358 1.784zm17.664 14.182c.816 0 1.516-.288 2.1-.865a2.83 2.83 0 00.876-2.09c0-.815-.292-1.515-.876-2.1a2.864 2.864 0 00-2.1-.875c-.802 0-1.498.292-2.09.876-.59.584-.885 1.284-.885 2.1 0 .801.295 1.494.886 2.078.59.584 1.287.876 2.09.876zm14.224-.422l14.16-26.23v-3.863H77.389v4.369h15.448L78.612 84.41h5.53zm34.378 0v-5.888h4.137v-4.368h-4.137V54.318h-7.407L99.526 74.134v4.39h14.14v5.887h4.853zm-4.853-10.256h-9.413l9.413-16.713v16.713zm17.094-7.027c1.829 0 3.383-.647 4.664-1.942 1.28-1.308 1.92-2.877 1.92-4.706 0-1.814-.64-3.369-1.92-4.663-1.28-1.295-2.835-1.942-4.664-1.942-1.815 0-3.37.647-4.664 1.942-1.295 1.294-1.942 2.849-1.942 4.663 0 1.843.644 3.412 1.931 4.706 1.288 1.295 2.846 1.942 4.675 1.942zm2.321 17.304l15.913-30.156h-4.221l-15.87 30.156h4.178zm-2.321-20.66c-.9 0-1.675-.32-2.322-.96a3.157 3.157 0 01-.97-2.332c0-.914.323-1.684.97-2.31a3.222 3.222 0 012.322-.94c.914 0 1.688.317 2.321.95.633.633.95 1.4.95 2.3 0 .915-.313 1.692-.94 2.332-.625.64-1.403.96-2.331.96zm16.609 20.998c1.814 0 3.359-.647 4.632-1.942 1.273-1.294 1.91-2.849 1.91-4.663 0-1.83-.64-3.387-1.92-4.675-1.281-1.287-2.822-1.93-4.622-1.93-1.83 0-3.391.643-4.686 1.93-1.294 1.288-1.941 2.846-1.941 4.675 0 1.828.644 3.386 1.93 4.674 1.288 1.287 2.853 1.93 4.697 1.93zm0-3.335c-.93 0-1.71-.32-2.343-.96a3.168 3.168 0 01-.95-2.31c0-.929.317-1.71.95-2.343s1.414-.95 2.343-.95c.886 0 1.656.324 2.31.971.655.647.982 1.421.982 2.322 0 .9-.324 1.67-.971 2.31-.647.64-1.421.96-2.321.96z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationIntro);
export default __webpack_public_path__ + "static/media/illustration-intro.cb9a8a9551ca99f99a125230d38a2c36.svg";
export { ForwardRef as ReactComponent };